import React, { useEffect } from 'react';
import { navigate } from 'gatsby';
import { AccountPanelTypes } from '../../AccountPanelTypes';
import { sideBarConfig } from '../../helpers/LayoutSideBarConfig';
import { AccountIconHelper } from '../../helpers/AccountIconsHelper';
import { smallScreenIconSize } from '../../constants/accountPanelConfigs';
import { weakKey } from '../../../../utilities/weakKey';

export const HomePage: AccountPanelTypes.THomePage = props => {
  const { Id, location } = props;
  let previousPage = 'pay-rent';
  if (location && location.state && location.state.prevPage) {
    previousPage = location.state.prevPage;
  }
  useEffect(() => {
    if (Id) {
      navigate(`../${Id}/${previousPage}`, {
        replace: true,
      });
    }
  });
  return <></>;
};

export const SmallScreenHomePage = () => {
  return (
    <div className="is-hidden-desktop homePageMenuContainer">
      {sideBarConfig.map(
        ({ url, linkName, icon, RenderAs }: AccountPanelTypes.TSideBarItem) => (
          <RenderAs to={`./${url}`} className="menuItem" key={weakKey({ url })}>
            <AccountIconHelper
              icon={icon}
              color="primary"
              size={smallScreenIconSize}
            />
            <span>{linkName}</span>
          </RenderAs>
        )
      )}
    </div>
  );
};
